import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container m-auto p-4 md:py-6">
      <div className="text-grey-1000 leading-normal">
        <div>
          <div>
            <h2 className="text-3xl font-semibold mb-2 leading-loose">
              Terms and Conditions
            </h2>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-1 leading-loose">1. Purpose of the Agreement</h2>
            <p className="mb-3">
              This agreement ("User Agreement") outlines the terms and conditions under which Yatra Tickets Pvt. Ltd. ("Yatra Tickets") and its affiliates provide services to users ("the User") who seek to purchase or inquire about products or services via Yatra Tickets' website or other customer interface channels.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">2. User's Acceptance of the Agreement</h2>
            <p className="mb-3">
              In addition to this agreement, specific terms of service (TOS) may apply to individual services or products provided by Yatra Tickets. In case of a conflict between such TOS and this agreement, the terms of this agreement shall prevail. Users are required to read and accept the relevant TOS before availing of services or products.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">3. Service-Specific Terms</h2>
            <p className="mb-3">
              In addition to this agreement, specific terms of service (TOS) may apply to individual services or products provided by Yatra Tickets. In case of a conflict between such TOS and this agreement, the terms of this agreement shall prevail. Users are required to read and accept the relevant TOS before availing of services or products.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">4. Third-Party Services and Responsibilities</h2>
            <p className="mb-3">
              Yatra Tickets may provide access to third-party services (e.g., flights, hotel bookings). The User is responsible for complying with the terms, conditions, and guidelines of these third-party service providers.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">5. Fees and Payments</h2>
            <p className="mb-3">
              Yatra Tickets reserves the right to charge transaction fees for services and to modify these fees without prior notice. Users are responsible for all charges, taxes, and fees related to their transactions. Refunds, where applicable, will be processed according to the policies of the respective service providers.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">6. Confidentiality</h2>
            <p className="mb-3">
              Users are required to maintain the confidentiality of any information deemed confidential by Yatra Tickets unless disclosure is required by law.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">7. User's Mobile Number</h2>
            <p className="mb-3">
              Yatra Tickets may send booking confirmations, payment details, and other relevant information via SMS or voice call to the User’s provided contact number. The User consents to receiving such communications.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">8. Burden of Proof</h2>
            <p className="mb-3">
              Yatra Tickets is responsible only for transactions conducted through its channels. Users must ensure the legality of their transactions under applicable laws.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">9. Linked Websites</h2>
            <p className="mb-3">
              Yatra Tickets is not responsible for the content or accuracy of linked third-party websites. Users should verify the information independently.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">10. Force Majeure</h2>
            <p className="mb-3">
              Yatra Tickets is not liable for non-performance or delays due to events beyond its control, such as natural disasters, strikes, or government actions. In such cases, refunds will be processed after deducting applicable charges.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">11. Liability</h2>
            <p className="mb-3">
              Yatra Tickets' liability is limited to the refund of the amount paid by the User for services, excluding any direct, indirect, or consequential damages.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">12. Safety of Data</h2>
            <p className="mb-3">
              The User agrees to bear responsibility for any data or material downloaded from Yatra Tickets' website. Yatra Tickets will endeavor to keep its platforms free of viruses and malware.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">13. Insurance</h2>
            <p className="mb-3">
              Yatra Tickets does not provide insurance unless explicitly stated. Any insurance offered will be subject to the terms of the insurance provider.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">14. Intellectual Property</h2>
            <p className="mb-3">
              All materials provided by Yatra Tickets are protected by intellectual property laws. Users may not use these materials without express permission.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">15. Visa Obligations</h2>
            <p className="mb-3">
              The User is responsible for obtaining the necessary visas for travel. Yatra Tickets is not liable for any issues arising from visa requirements.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">16. Use Limitation</h2>
            <p className="mb-3">
              Yatra Tickets' services are for personal use only. Unauthorized commercial use is prohibited.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">17. Indemnification</h2>
            <p className="mb-3">
              The User agrees to indemnify Yatra Tickets against any losses, damages, or legal fees arising from their use of Yatra Tickets' services or violation of this agreement.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">18. Right to Refuse Service</h2>
            <p className="mb-3">
              Yatra Tickets reserves the right to refuse service or cancel bookings if the User provides incorrect or misleading information.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">19. Severability</h2>
            <p className="mb-3">
              If any provision of this agreement is found to be unenforceable, the remaining provisions will continue in full force.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">20. Relationship</h2>
            <p className="mb-3">
              This agreement establishes a contractual relationship between Yatra Tickets and the User, governed by the laws of Nepal.
            </p>

            <h2 className="text-xl font-semibold mb-1 leading-loose">21. Updates to Information</h2>
            <p className="mb-3">
              Yatra Tickets may update or correct information on its website without prior notice. Users are encouraged to report inaccuracies.
            </p>

          </div>

        </div>
      </div>
    </div>




  );
};

export default TermsAndConditions;
